"use client"

import { motion } from "framer-motion"
import ChatItem from "./ChatItem"
import { useContext, useEffect } from "react"
import ChatContext from "@/context/chatContext"

export default function ChatList({ activeChat, handleSelectChat }) {
  const { chatData, setChatData, fetchChats } = useContext(ChatContext) // Asegúrate de que el contexto tiene `fetchChats`

  

  // Si no hay chats, intenta obtenerlos nuevamente después de 5 segundos
  useEffect(() => {
    if (Array.isArray(chatData) && chatData.length === 0) {
      const timer = setTimeout(fetchChats, 5000) // Llama a la función del contexto
      return () => clearTimeout(timer)
    }
  }, [chatData, fetchChats])

  return (
    <motion.div
      className="w-full md:w-1/3 bg-white border-r border-gray-200"
      initial={{ x: -300, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -300, opacity: 0 }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
    >
      
      <div className="overflow-y-auto h-[calc(100vh-64px)] bg-[var(--beige-light)]">
      <div className="p-5 border-b border-gray-200 bg-[var(--navy-blue-light)] h-19">
        <h1 className="text-2xl font-bold text-white">Chats</h1>
      </div>
        {Array.isArray(chatData) && chatData.length > 0 ? (
          chatData.map((chat) => (
            <ChatItem
              key={chat.chatId}
              chat={chat}
              isActive={activeChat === chat.chatId}
              onSelect={() => handleSelectChat(chat.chatId)}
            />
          ))
        ) : (
          <div className="p-4 text-center text-gray-500">
            No hay chats disponibles
            <br />
            <span className="text-sm">Reintentando en 5 segundos...</span>
          </div>
        )}
      </div>
    </motion.div>
  )
}
